// ConciergeInput - Message input with auto-resize

import React, { useState, useRef, useEffect, KeyboardEvent } from 'react';
import { Send } from 'lucide-react';

interface ConciergeInputProps {
  onSend: (text: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export function ConciergeInput({
  onSend,
  disabled = false,
  placeholder = 'Was fuer einen Ort suchst du?',
}: ConciergeInputProps) {
  const [text, setText] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // Auto-resize textarea
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${Math.min(textarea.scrollHeight, 128)}px`;
    }
  }, [text]);

  const handleSend = () => {
    if (text.trim() && !disabled) {
      onSend(text.trim());
      setText('');
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="flex items-end gap-2 p-4 bg-white border-t border-gray-200">
      <textarea
        ref={textareaRef}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        rows={1}
        className="
          flex-1 resize-none
          px-4 py-3
          bg-gray-100 rounded-2xl
          border-0 outline-none
          focus:ring-2 focus:ring-indigo-500 focus:bg-white
          placeholder-gray-500
          text-gray-900
          max-h-32
          disabled:opacity-50
        "
      />
      <button
        onClick={handleSend}
        disabled={disabled || !text.trim()}
        className="
          w-11 h-11 flex-shrink-0
          flex items-center justify-center
          bg-indigo-500 rounded-full
          hover:bg-indigo-600
          disabled:bg-gray-300 disabled:cursor-not-allowed
          transition-colors
        "
        aria-label="Nachricht senden"
      >
        <Send className="w-5 h-5 text-white" />
      </button>
    </div>
  );
}

export default ConciergeInput;
